/**
 * Simple Authentication Logger
 * All logging methods are no-ops to reduce console noise
 * Can be re-enabled for debugging by uncommenting console.log statements
 */

export class AuthLogger {
  private static readonly PREFIX = '[AUTH]';

  /**
   * Log environment detection
   */
  static logEnvironment(_env: 'dev' | 'qa' | 'prod'): void {
    // Logging disabled
  }

  /**
   * Log initialization start
   */
  static logInitStart(): void {
    // Logging disabled
  }

  /**
   * Log cortex_session check in production
   */
  static logCortexSessionCheck(_found: boolean, _isValid: boolean = false): void {
    // Logging disabled
  }

  /**
   * Log authentication result
   */
  static logAuthResult(_success: boolean, _method: 'cortex_session' | 'login' | 'none'): void {
    // Logging disabled
  }

  /**
   * Log user info after successful auth
   */
  static logUserInfo(_operatorId: string | null, _distributorId: string | null, _isDistributor: boolean): void {
    // Logging disabled
  }

  /**
   * Log login attempt
   */
  static logLoginAttempt(_username: string): void {
    // Logging disabled
  }

  /**
   * Log failed login attempt for security monitoring
   */
  static logLoginFailure(username: string, reason: string): void {
    console.warn(`${this.PREFIX} Login failed for user: ${username} - Reason: ${reason}`);
  }

  /**
   * Log logout
   */
  static logLogout(): void {
    // Logging disabled
  }

  /**
   * Log error
   */
  static logError(message: string, error?: unknown): void {
    console.error(`${this.PREFIX} Error: ${message}`, error || '');
  }

  /**
   * Log general info
   */
  static logInfo(_message: string, _data?: unknown): void {
    // Logging disabled
  }

  /**
   * Log initialization complete
   */
  static logInitComplete(): void {
    // Logging disabled
  }
}
